export default __webpack_public_path__ + "static/feedback_avatar2-1db261dc0c46465c0642e65fd2b53b81.webp";